import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { CommonModule } from '@angular/common';
import { AppIconComponent, AppSpinnerComponent } from '../../../lib/ui';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, RouterLink, AppIconComponent, AppSpinnerComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  isLoading = true;

  private router = inject(Router);
  private keycloakService = inject(KeycloakService);

  async ngOnInit() {
    this.isLoading = true;

    try {
      // Verificar se já está logado
      const isLoggedIn = await this.keycloakService.isLoggedIn();

      if (isLoggedIn) {
        // Já está autenticado, redirecionar para o dashboard
        this.router.navigate(['/dashboard']);
        return;
      }

      // Não está autenticado, mostrar tela de login
      this.isLoading = false;
    } catch (error) {
      console.error('Erro ao verificar login:', error);
      this.isLoading = false;
    }

    // Não iniciar login automaticamente, deixar o usuário clicar no botão
    // ou mostrar mensagem de erro se houve falha ao verificar login
  }

  async loginWithKeycloak() {
    await this.keycloakService.login();
  }

  goToHome() {
    this.router.navigate(['/home']);
  }
}
